import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { isNumber } from "@grandvisionhq/utils";
import { useSolutionsEcommContext } from "../../../../../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
import { SubscriptionDailyIntervalPriceCaption } from "../../../../../../../../../../components/CTAs/components/modules/EcommContent/components/CTAs/components/SubscriptionDailyIntervalPriceCaption.js";
import { SinglePurchasePriceCaption } from "../../../../../../../../../../components/CTAs/components/modules/EcommContent/components/CTAs/components/SinglePurchasePriceCaption.js";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
import { isSubscriptionPurchase, isSinglePurchase } from "../../../../../../../../../../../../types/types/typeguards.js";
const SolutionsCTACaption = () => {
  const { getLabel } = useIntl();
  const { displayPrice, selectedPurchaseType } = useProductData();
  const { state } = useSolutionsEcommContext();
  const { subscriptionPurchaseConfigurations, quantity } = state.configurations;
  const { deliveryInterval } = subscriptionPurchaseConfigurations;
  const unitPrice = displayPrice.discountedPrice ?? displayPrice.originalPrice;
  const totalPrice = quantity * unitPrice;
  const addToCartLabel = getLabel("products.solutions.addToBasket");
  if (isSubscriptionPurchase(selectedPurchaseType) && isNumber(totalPrice) && !!deliveryInterval) {
    return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body-head" }, addToCartLabel, /* @__PURE__ */ React.createElement(
      SubscriptionDailyIntervalPriceCaption,
      {
        isCentAmount: false,
        price: totalPrice,
        priceInterval: deliveryInterval
      }
    ));
  }
  if (isSinglePurchase(selectedPurchaseType) && isNumber(totalPrice) && quantity > 1) {
    return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body-head" }, addToCartLabel, /* @__PURE__ */ React.createElement(SinglePurchasePriceCaption, { isCentAmount: false, price: totalPrice }));
  }
  return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body-head" }, addToCartLabel);
};
export {
  SolutionsCTACaption
};
//# sourceMappingURL=SolutionsCTACaption.js.map
